<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <b-modal id="pay-modal" hide-footer>
            <!-- Modal body -->
            <div class="modal-body text-xl text-gray-500">
                {{ $t('payWarning') }}
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
                <b-button type="button" class="btn h-11 border-0 bg-denyColor hover:bg-hoverDenyColor focus:ring-0 rounded w-32 font-bold" data-dismiss="modal" @click="payDebts">{{
                        $t('yes')
                    }}
                </b-button>
                <button type="button" class="btn h-11 border-0 bg-main hover:bg-hoverMain text-white focus:ring-0 rounded w-32 font-bold" data-dismiss="modal" @click="$bvModal.hide('pay-modal')">
                    {{ $t('no') }}
                </button>
            </div>
        </b-modal>

        <b-modal size="xl" id="my-modal-data" :title="$t('debt')" ok-only>
            <table class="w-full mt-3">
                <thead class="bg-lightGray h-11">
                <tr>
                    <th class="d-none d-lg-table-cell pl-3">{{ $t('printView.receipt') }}</th>
                    <th>{{ $t('printView.totalSum') }}</th>
                    <th>{{ $t('date') }}</th>
                    <th class="d-none d-lg-table-cell">{{ $t('additionalInformation') }}</th>
                    <th>{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody
                    v-for="item in getDebt.sales"
                    :key="item.id"
                >
                <tr class="h-11 cursor-pointer">
                    <td class="d-none d-lg-table-cell pl-3" @click="goToDetails(item.id)">{{ item.id }}</td>
                    <td @click="goToDetails(item.id)">{{ showCurrencyById(item.currency.id, item.totalPrice) }}</td>
                    <td @click="goToDetails(item.id)">
                        {{ dateTimeFormat(item.createdAt, false) }}
                    </td>
                    <td class="d-none d-md-table-cell text-green-500" @click="goToDetails(item.id)">
                        {{ textSplice(item.description) }}
                    </td>
                    <td>
                        <span
                            v-if="saleId !== item.id"
                            @click="saleId = item.id"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 4px 7px 2px 7px"
                        >&#9660;</span>
                        <span
                            v-else @click="saleId = null"

                            style="background-color: #2C0FDE; color: #FFFFFF; border-radius: 3px; padding: 2px 7px 4px 7px"
                        >&#9650;</span>
                    </td>
                </tr>
                <tr v-if="saleId === item.id">
                    <td colspan="7">
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <table class="table pr-10 pl-10" style="box-shadow: 0 4px 6px 0; border-radius: 5px">
                                <thead>
                                <tr>
                                    <th class="d-none d-sm-table-cell">#</th>
                                    <th>{{ $t('product.title') }}</th>
                                    <th>{{ $t('amount') }}</th>
                                    <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                                    <th>{{ $t('sale.sum') }}</th>
                                </tr>
                                </thead>
                                <tbody
                                    v-for="(saleProduct, index) in item.saleProducts"
                                    :key="saleProduct.id"
                                >
                                <tr>
                                    <td class="d-none d-sm-table-cell">
                                        {{ index + 1 }}
                                    </td>
                                    <td> {{ saleProduct.product.name }}</td>
                                    <td>
                                        {{
                                            parseFloat(saleProduct.amount) + ' ' + showUnitOfMeasure(saleProduct.product.unitOfMeasure)
                                        }}
                                    </td>
                                    <td class="d-none d-sm-table-cell">
                                        {{ showCurrencyById(item.currency.id, saleProduct.price) }}
                                    </td>
                                    <td>{{
                                            showCurrencyById(item.currency.id, saleProduct.price * saleProduct.amount)
                                        }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </Row>
                        <Row
                            type="form-row"
                            class="col-sm-10 m-0 pt-2 my-2 justify-content-end"
                        >
                            <div class="col-12 col-lg-4 mb-3 mb-lg-0" v-if="item.description !== null">
                                <span class="text-uppercase font-weight-bold">
                                   {{ $t('additionalInformation') }}
                                </span>
                                <span
                                    class="d-block"
                                    style="border: 1px solid; border-radius: 3px"
                                >
                                    {{ item.description }}
                                </span>
                            </div>
                            <div class="col-12 col-lg-8">
                                <div
                                    class=" col-12 table-bordered text-uppercase font-weight-bold d-flex "
                                    style="color: #081EE8; border-radius: 5px"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('printView.totalSum') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #14F00F"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('payed') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right"> {{
                                                showCurrencyById(item.currency.id, item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>

                                <div
                                    class="col-12 table-bordered font-weight-bold d-flex"
                                    style="color: #E30000"
                                >
                                    <div class="col-6">
                                        <h5>{{ $t('debt') }}</h5>
                                    </div>
                                    <div class="col-6">
                                        <h5 class="float-right">{{
                                                showCurrencyById(item.currency.id, item.totalPrice - item.payedAmount)
                                            }}</h5>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="grid grid-cols-12 gap-3 mt-4">
                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3 ml-2">
                        {{ $t('printView.totalSum') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(baseCurrencyId, getDebt.totalSum) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3 ml-2">
                        {{ $t('payed') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(baseCurrencyId, getDebt.totalPayment) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 absolute -top-3 ml-2">
                        {{ $t('debt') }}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(baseCurrencyId, totalDebt) }}
                    </div>
                </div>
            </div>
        </b-modal>

        <!--    checkbox    -->
        <div class="py-4">
            <div class="col-12 col-md-4 mt-2 btn-group btn-group-toggle" data-toggle="buttons">
                <label v-if="!getCustomer.isCompany || $route.name === 'customers/add'" class="btn btn-primary button-stat active font-bold flex justify-center items-center" style="height: 44px !important;">
                    <input id="person" type="radio" @click="goPerson" name="options" checked>{{ $t('person.title') }}
                </label>
                <label v-if="getCustomer.isCompany || $route.name === 'customers/add'" class="btn btn-primary button-stat font-bold flex justify-center items-center" style="height: 44px !important;">
                    <input id="company" type="radio" @click="goCompany" name="options">{{ $t('company.title') }}
                </label>
            </div>
        </div>

        <!--  person form    -->
        <template v-if="!modelForm.isCompany">
            <div class="container font-bold text-gray-500 text-2xl">
                {{ $t('customer.personalInformation') }}
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4 container">
                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.givenName') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="givenName"
                        :model-form="modelForm"
                        :errors="errors"
                        check-to-model="modelNotEmptyState"
                        :column-no-top-margin="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.familyName') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="familyName"
                        :model-form="modelForm"
                        :column-is-fill="false"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.additionalName') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="additionalName"
                        :model-form="modelForm"
                        :column-is-fill="false"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.birthday') }}
                    </div>
                    <InputBox
                        class="px-0"
                        type="date"
                        value="10-10-2013"
                        model-name="birthday"
                        :model-form="modelForm"
                        :no-margin-top="true"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.telephone') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="telephone"
                        check-to-model="modelPhoneOrEmpty"
                        :model-form="modelForm"
                        :errors="errors"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('person.gender.title') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <b-form-select v-model="modelForm.gender" class="h-11 border-gray-300 focus:ring-0">
                        <b-form-select-option :value="1">{{ $t('person.gender.man') }}</b-form-select-option>
                        <b-form-select-option :value="0">{{ $t('person.gender.woman') }}</b-form-select-option>
                    </b-form-select>
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('user.email') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="email"
                        :model-form="modelForm"
                    />
                </div>
            </div>

            <div v-if="this.$route.name !=='customers/add' && canSeeCustomerDebts() && parseFloat(sumDebt)" class="grid grid-cols-12 container mt-4">
                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2 h-7">
                        <span @click="sumDebt > 0 ? $bvModal.show('my-modal-data'): ''" class="cursor-pointer font-bold">{{ $t('debt') }} {{ numberWithCommas(this.sumDebt) }}</span>

                        <b-form-select v-if="sumDebt > 0" class="border-0 w-20 focus:ring-0" v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    <b-form-input
                        class="border-gray-300 focus:ring-0 h-11"
                        v-model="payDebt"
                        type="number"
                        min="0"
                        @input="changeInput"
                    />

                    <span v-if="isMore" class="text-red-500 font-bold absolute">{{ $t('errorData') }}</span>
                </div>

                <div class="col-span-2 mt-7 pr-3">
                    <button
                        type="button"
                        class="h-11 bg-main rounded-r border-0 w-full font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore"
                        @click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('filter.all') }}
                    </button>
                </div>

                <div class="col-span-2 mt-7">
                    <button
                        type="button"
                        class="h-11 bg-main rounded border-0 w-32 font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore || payDebt === null || payDebt === '' || payDebt === '0'"
                        @click.prevent="$bvModal.show('pay-modal')"
                    >
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('pay') }}
                    </button>
                </div>
            </div>
        </template>

        <!--  company form    -->
        <template v-if="modelForm.isCompany">
            <div class="container font-bold text-gray-500 text-2xl">
                {{ $t('customer.personalInformation') }}
            </div>

            <div class="grid grid-cols-12 gap-3 mt-4 container">
                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('company.name') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="companyName"
                        :model-form="modelForm"
                        :errors="errors"
                        check-to-model="modelNotEmptyState"
                        :column-no-top-margin="true"
                        :model-state="modelNotEmptyState"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('Inn') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="jshshir"
                        :model-form="modelForm"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('customer.bankAccountNum') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="bankAccountNumber"
                        :model-form="modelForm"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('customer.createdAtCompany') }}
                    </div>
                    <InputBox
                        class="px-0"
                        type="date"
                        model-name="createdAt"
                        :model-form="modelForm"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('company.telephone') }}<span class="text-red-500 text-xl">*</span>
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="companyTelephone"
                        check-to-model="modelPhoneOrEmpty"
                        :model-form="modelForm"
                        :errors="errors"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('customer.webSite') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="webSite"
                        :model-form="modelForm"
                    />
                </div>

                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                        {{ $t('user.email') }}
                    </div>
                    <InputBox
                        class="px-0"
                        model-name="email"
                        :model-form="modelForm"
                    />
                </div>
            </div>

            <div v-if="this.$route.name !=='customers/add' && canSeeCustomerDebts() && parseFloat(sumDebt)" class="grid grid-cols-12 container mt-4">
                <div class="col-span-12 md:col-span-4 position-relative pl-0 mt-7">
                    <div v-if="canManagerSuppliers()" class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2 h-7">
                        <span @click="sumDebt > 0 ? $bvModal.show('my-modal-data'): ''" class="cursor-pointer font-bold">{{ $t('debt') }} {{ numberWithCommas(this.sumDebt) }}</span>

                        <b-form-select v-if="sumDebt > 0" class="border-0 w-20 focus:ring-0" v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                    <b-form-input
                        class="border-gray-300 focus:ring-0 h-11"
                        v-model="payDebt"
                        type="number"
                        min="0"
                        @input="changeInput"
                    />

                    <span v-if="isMore" class="text-red-500 font-bold absolute">{{ $t('errorData') }}</span>
                </div>

                <div class="col-span-2 mt-7 pr-3">
                    <button
                        type="button"
                        class="h-11 bg-main rounded-r border-0 w-full font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore"
                        @click.prevent="$bvModal.show('pay-modal'); payDebt = sumDebt">
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('filter.all') }}
                    </button>
                </div>

                <div class="col-span-2 mt-7">
                    <button
                        type="button"
                        class="h-11 bg-main rounded border-0 w-32 font-bold focus:ring-0 focus:outline-none text-white hover:bg-hoverMain"
                        :disabled="isMore || payDebt === null || payDebt === '' || payDebt === '0'"
                        @click.prevent="$bvModal.show('pay-modal')"
                    >
                        <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('pay') }}
                    </button>
                </div>
            </div>

        </template>

        <div class="container">
            <SearchCollapse text-button="additionalInformation" :is-bg-white="true">

                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('customer.factAddress') }}
                        </div>
                        <textarea
                            v-model="modelForm['factAddress']"
                            rows="3"
                            class="w-full rounded border-gray-300"
                        ></textarea>
                    </div>

                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('additionalInformation') }}
                        </div>
                        <textarea
                            v-model="modelForm['additionalInformation']"
                            rows="3"
                            class="w-full rounded border-gray-300"
                        ></textarea>
                    </div>

                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('addDebt') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="debt"
                            :model-form="modelForm"
                            :errors="errors"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-6 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('currency') }}
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="modelForm.currencyId">
                            <b-form-select-option :value=3>UZS</b-form-select-option>
                            <b-form-select-option :value=1>USD</b-form-select-option>
                            <b-form-select-option :value=2>RUB</b-form-select-option>
                        </b-form-select>
                    </div>
                </div>

                <div class="h-5 bg-lightGray -mx-4 mt-4"></div>

                <div class="grid grid-cols-12">
                    <div class="col-span-12 md:col-span-3 font-bold text-gray-500 text-2xl mt-4">
                        {{ $t('customer.loyaltyCard') }}
                    </div>

                    <div class="col-span-12 md:col-span-6">
                        <CheckBoxRow
                            model-name="hasCard"
                            true-text="customer.scoreAndDiscount"
                            column-size="4"
                            :model-form="modelForm"
                            md-size="8"
                            class="pt-4"
                        />
                    </div>
                </div>

                <div v-if="modelForm.hasCard" class="grid grid-cols-12 gap-3">
                    <div class="col-span-12 md:col-span-4 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('customer.loyaltyCard') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="number"
                            :model-form="cashbackCardDto"
                            :errors="errors"
                            check-to-model="modelNumberAndThirteenDigitState"
                        />
                        <div v-if="!isNumberAvailable" class="text-purple-500 text-xs">
                            {{ $t('customer.cashback.numberNotAvailable') }}
                        </div>
                    </div>

                    <div class="col-span-12 md:col-span-4 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('sale.saleSum') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="minSaleAmount"
                            :model-form="cashbackCardDto"
                            :errors="errors"
                            check-to-model="modelNumberState"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-2 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('currency') }}
                        </div>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="currentCurrencyShortName">
                            <b-form-select-option value="UZS">UZS</b-form-select-option>
                            <b-form-select-option value="USD">USD</b-form-select-option>
                            <b-form-select-option value="RUB">RUB</b-form-select-option>
                        </b-form-select>
                    </div>

                    <div class="col-span-12 md:col-span-2 relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute -top-3 ml-2">
                            {{ $t('sale.discount.percentAmount') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="percent"
                            :model-form="cashbackCardDto"
                            :errors="errors"
                            check-to-model="modelNumberState"
                        />
                    </div>
                </div>
            </SearchCollapse>
        </div>

        <div class="container py-4" v-if="modelForm.isCompany">
            <SubmitRow
                v-if="canManageCustomers()"
                :text="submitButtonName"
                :is-disabled="hasErrorsIn(errorsCompany)"
                :is-loading="isLoading"
                :do-action="addOrEdit"
            />
        </div>
        <div class="container py-4" v-if="!modelForm.isCompany">
            <SubmitRow
                v-if="canManageCustomers()"
                :text="submitButtonName"
                :is-disabled="hasErrorsIn(errorsPerson) || !isNumberAvailable"
                :is-loading="isLoading"
                :do-action="addOrEdit"
            />
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import Row from "../../components/html/Row";
import InputBox from "../../components/InputBox";
import CheckBoxRow from "../../components/CheckBoxRow";
import SubmitRow from "../../components/SubmitRow";
import Modal from "../../components/html/Modal";
import accessMixin from "../../mixin/accessMixin";
import currencyFormatMixin from "../../mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import SearchCollapse from "../../components/SearchCollapse";
import currencyRateMixin from "@/mixin/currencyRateMixin";

export default {
    name: "CustomerAdd",
    components: {
        SubmitRow,
        CheckBoxRow,
        InputBox,
        Row,
        Modal,
        SearchCollapse
    },
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            saleId: null,
            hasSalesCustomer: false,
            color: '#FFEEBA',
            search: {
                customerId: this.$route.params.id,
                isPayed: null,
                after: '',
                before: '',
                totalPriceMin: '',
                totalPriceMax: '',
                page: this.$route.params.page
            },
            options: [
                {text: this.$t('filter.all'), value: null},
                {text: this.$t('payed'), value: true},
                {text: this.$t('onCredit'), value: false}
            ],
            submitButtonName: 'add',
            modalText: '',
            isLoading: false,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'customer.title', url: 'customers'},
                this.$route.name === 'customers/add' ? {name: 'add'} : {name: 'edit'},
            ],
            errors: {
                companyName: null,
                companyTelephone: null,
                givenName: null,
                telephone: null,
                email: null,
                number: null,
                minSaleAmount: null,
                percent: null,
            },
            modelForm: {
                id: null,
                customerId: null,
                jshshir: '',
                isCompany: false,
                hasCard: false,
                birthday: null,
                createdAt: null,
                bankAccountNumber: null,
                companyName: '',
                companyTelephone: '',
                email: '',
                givenName: '',
                familyName: '',
                additionalName: '',
                additionalInformation: '',
                gender: 1,
                telephone: '',
                debt: '',
                currencyId: 3,
                score: '',
                webSite: '',
                factAddress: '',
            },
            cashbackCardDto: {
                number: null,
                isCashback: true,
                minSaleAmount: null,
                percent: null,
                score: null,
                cashbackAmount: null,
                scoreAmount: null,
                currency: null
            },
            customerDebt: 0,
            customerName: '',
            payDebt: null,
            totalDebt: 0,
            sumDebt: 0,
            isMore: false,
            isScore: false,
        }
    },
    computed: {
        ...mapGetters([
            'getCustomer',
            'getDebt',
            'getUserCompanyId',
            'getCurrencyByShortName',
            'getSales',
            'getSalesTotalCount',
            'getCustomerSalesTotalAmount',
            'isNumberAvailable'
        ]),
        errorsCompany() {
            return {
                companyName: this.errors.companyName,
                companyTelephone: this.errors.companyTelephone,
                email: this.errors.email
            }
        },
        errorsPerson() {
            return this.modelForm.hasCard ? {
                givenName: this.errors.givenName,
                telephone: this.errors.telephone,
                email: this.errors.email,
                number: this.errors.number,
                minSaleAmount: null,
                percent: null,
            } : {
                givenName: this.errors.givenName,
                telephone: this.errors.telephone,
                email: this.errors.email,
            }
        }
    },
    watch: {
        'currentCurrencyShortName'(newVal, oldVal) {
            this.sumDebt = this.calculateAmountByBaseCurrency(this.sumDebt, oldVal, newVal)
        },
        'modelForm.hasCard'() {
            if (this.$route.name === 'customers/add') {
                if (this.modelForm.hasCard) {
                    this.cashbackCardDto.number = Math.floor(Math.random() * 10000000000000)
                    this
                        .checkCashbackNumberAvailability(this.cashbackCardDto.number.toString())
                        .then(() => {
                            if (!this.isNumberAvailable) {
                                this.cashbackCardDto.number = Math.floor(Math.random() * 10000000000000)
                            }
                        })
                    this.cashbackCardDto.minSaleAmount = 1000
                    this.cashbackCardDto.percent = 10
                    setTimeout(() => {
                        this.cashbackCardDto.minSaleAmount = ''
                        this.cashbackCardDto.percent = ''
                    }, 100)

                } else {
                    this.cashbackCardDto.number = null
                }
            }
        },
        'cashbackCardDto.number'() {
            if (this.cashbackCardDto.number.length === 13) {
                this
                    .checkCashbackNumberAvailability(this.cashbackCardDto.number.toString())
                    .then(() => {
                        console.log(this.isNumberAvailable)
                    })
            } else {
                this.changeNumberAvailability()
            }
        }
    },
    methods: {
        ...mapActions([
            'putCustomer',
            'pushCustomer',
            'fetchCustomer',
            'fetchUser',
            'fetchCompany',
            'fetchDebt',
            'payToCustomer',
            'fetchSalesCustomer',
            'searchSales',
            'fetchCustomerSalesTotalAmount',
            'setBreadcrumbItems',
            'checkCashbackNumberAvailability',
            'changeNumberAvailability'
        ]),
        goCompany() {
            this.modelForm.isCompany = true
        },
        goPerson() {
            this.modelForm.isCompany = false
        },
        textSplice(text) {
            if (text !== null) {
                if (text.length > 20) {
                    return text.slice(0, 20) + ' . . .'
                }
                return text
            }

            return "-"
        },
        getCustomerName(customer) {
            return customer.isCompany ?
                customer.customerCompany.name :
                customer.person.givenName + ' ' + customer.person.familyName
        },
        changeInput() {
            this.isMore = parseInt(this.payDebt) > parseInt(this.sumDebt);
        },
        goToDetails(id) {
            this.$i18nHelper.toUrl('sales/transactions/' + id)
        },
        showOrHideSalesHistory() {
            this.hasSalesCustomer = !this.hasSalesCustomer
        },
        resetSaleSearchInfo() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.searchSalesInfo()
        },
        backgroundColor(amount) {
            if (amount > 0) {
                return this.color
            }
        },
        searchSalesInfo() {
            this.$root.showOverlay = true
            this.search.page = 1

            this.fetchSalesCustomer(this.search)
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    this.$root.showOverlay = false
                });
        },
        payDebts() {
            this.$bvModal.hide('pay-modal')
            this.$root.showOverlay = true

            this.payToCustomer({
                id: this.$route.params.id,
                paymentAmount: parseFloat(this.payDebt),
                currency: this.getCurrencyByShortName(this.currentCurrencyShortName)['@id']
            })
                .then(() => {
                    this.$router.go(0)
                })
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        getCurrencyId(shortName) {
            return this.getCurrencyByShortName(shortName)
        },
        makeCompanyData() {
            let data =  {
                isCompany: this.modelForm.isCompany,
                companyName: this.modelForm.companyName,
                jshshir: this.modelForm.jshshir,
                bankAccountNumber: this.modelForm.bankAccountNumber,
                createdAt: this.modelForm.createdAt,
                webSite: this.modelForm.webSite,
                email: this.modelForm.email,
                companyTelephone: this.modelForm.companyTelephone,
                factAddress: this.modelForm.factAddress,
                additionalInformation: this.modelForm.additionalInformation,
                debt: this.modelForm.debt,
                currency: '/api/currencies/' + this.modelForm.currencyId,
                hasCard: this.modelForm.hasCard
            }

            if (this.modelForm.hasCard) {
                data.cashbackCardDto = this.cashbackCardDto
                data.cashbackCardDto.currency = this.getCurrencyId(this.currentCurrencyShortName)['@id']
                data.cashbackCardDto.minSaleAmount = +data.cashbackCardDto.minSaleAmount
                data.cashbackCardDto.percent = +data.cashbackCardDto.percent
            }

            return data
        },
        makePersonData() {
            let data = {
                isCompany: this.modelForm.isCompany,
                personGivenName: this.modelForm.givenName,
                personFamilyName: this.modelForm.familyName,
                personAdditionalName: this.modelForm.additionalName,
                birthday: this.modelForm.birthday,
                personTelephone: this.modelForm.telephone,
                personGender: this.modelForm.gender,
                email: this.modelForm.email,
                factAddress: this.modelForm.factAddress,
                additionalInformation: this.modelForm.additionalInformation,
                debt: this.modelForm.debt,
                currency: '/api/currencies/' + this.modelForm.currencyId,
                hasCard: this.modelForm.hasCard
            }

            if (this.modelForm.hasCard) {
                data.cashbackCardDto = this.cashbackCardDto
                data.cashbackCardDto.currency = this.getCurrencyId(this.currentCurrencyShortName)['@id']
                data.cashbackCardDto.minSaleAmount = +data.cashbackCardDto.minSaleAmount
                data.cashbackCardDto.percent = +data.cashbackCardDto.percent
                data.cashbackCardDto.number = data.cashbackCardDto.number.toString()
            }

            return data
        },
        addCustomer() {
            if (this.modelForm.isCompany) {
                let data = this.makeCompanyData()

                this.pushCustomer(data)
                    .then(() => {
                        this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        if (reason === 'You have not available credits') {
                            this.modalText = this.$t('error.overLimit')
                            this.$bvModal.show('modal_show')
                        } else {
                            this.modalText = reason
                            this.$bvModal.show('modal_show')
                        }
                    })
            } else {
                let data = this.makePersonData()
                this.pushCustomer(data)
                    .then(() => {
                        this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            }
        },
        editCustomer() {
            if (this.modelForm.isCompany) {
                this.putCustomer({
                    url: 'customer_companies',
                    id: this.modelForm.id,
                    name: this.modelForm.companyName,
                    jshshir: this.modelForm.jshshir,
                    bankAccountNumber: this.modelForm.bankAccountNumber,
                    createdAt: this.modelForm.createdAt,
                    telephone: this.modelForm.companyTelephone,
                    webSite: this.modelForm.webSite,
                    additionalInformation: this.modelForm.additionalInformation
                })
                this.putCustomer({
                    url: 'customers',
                    id: this.modelForm.customerId,
                    email: this.modelForm.email,
                    factAddress: this.modelForm.factAddress
                })
                    .then(() => {
                        // this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            } else {
                this.putCustomer({
                    url: 'people',
                    id: this.modelForm.id,
                    givenName: this.modelForm.givenName,
                    familyName: this.modelForm.familyName,
                    additionalName: this.modelForm.additionalName,
                    birthday: this.modelForm.birthday,
                    telephone: this.modelForm.telephone,
                    gender: this.modelForm.gender,
                    additionalInformation: this.modelForm.additionalInformation
                })
                this.putCustomer({
                    url: 'customers',
                    id: this.modelForm.customerId,
                    email: this.modelForm.email,
                    factAddress: this.modelForm.factAddress
                })
                    .then(() => {
                        // this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            }
        },
        addOrEdit() {
            if (this.$route.name === 'customers/add') {
                this.isLoading = true

                this.addCustomer()

                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            } else {
                this.isLoading = true

                this.editCustomer()
                this.putCustomer({
                    url: 'customers',
                    id: this.$route.params.id,
                    debt: (Number(this.modelForm.debt) + Number(this.getCustomer.debt)).toString(),
                    currency: '/api/currencies/' + this.modelForm.currencyId,
                })
                    .then(() => {
                        this.$i18nHelper.toUrl('customers')
                    })
                    .catch((reason) => {
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })

                setTimeout(() => {
                    this.isLoading = false
                }, 5000)
            }
        },
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.name === 'customers/edit') {
            this.$root.showOverlay = true
            this.submitButtonName = 'edit'

            this.fetchCustomer(this.$route.params.id)
                .finally(() => {
                    if (this.canSeeCustomerDebts()) {
                        this.fetchCustomerSalesTotalAmount(this.$route.params.id)
                        this.fetchDebt(this.$route.params.id)
                            .then(() => {
                                this.sumDebt = parseFloat(this.getDebt.customerDebt)
                                this.totalDebt = this.getDebt.customerDebt.toFixed(2)
                            })
                    }

                    this.customerName = this.getCustomerName(this.getCustomer)
                    this.modelForm.customerId = this.getCustomer.id

                    if (this.getCustomer.hasCard) {
                        this.modelForm.hasCard = true
                        this.cashbackCardDto.number = this.getCustomer.cashbackCard.number
                        this.cashbackCardDto.minSaleAmount = parseInt(this.getCustomer.cashbackCard.minSaleAmount)
                        this.cashbackCardDto.minSaleAmount = this.cashbackCardDto.minSaleAmount.toString()
                        this.cashbackCardDto.percent = this.getCustomer.cashbackCard.percent
                        this.cashbackCardDto.currency = this.getCustomer.cashbackCard.currency['@id']
                    }

                    if (this.getCustomer.isCompany) {
                        document.getElementById('company').click()
                        this.modelForm.id = this.getCustomer.customerCompany.id
                        this.modelForm.companyName = this.getCustomer.customerCompany.name
                        this.modelForm.jshshir = this.getCustomer.customerCompany.jshshir
                        this.modelForm.bankAccountNumber = this.getCustomer.customerCompany.bankAccountNumber
                        this.modelForm.createdAt = this.getCustomer.customerCompany.createdAt
                        this.modelForm.companyTelephone = this.getCustomer.customerCompany.telephone ? this.getCustomer.customerCompany.telephone : ''
                        this.modelForm.webSite = this.getCustomer.customerCompany.webSite
                        this.modelForm.email = this.getCustomer.email
                        this.modelForm.factAddress = this.getCustomer.factAddress
                        this.modelForm.additionalInformation = this.getCustomer.customerCompany.additionalInformation
                    } else {
                        document.getElementById('person').click()
                        this.modelForm.id = this.getCustomer.person.id
                        this.modelForm.givenName = this.getCustomer.person.givenName
                        this.modelForm.familyName = this.getCustomer.person.familyName
                        this.modelForm.additionalName = this.getCustomer.person.additionalName
                        this.modelForm.birthday = this.getCustomer.person.birthday
                        this.modelForm.telephone = this.getCustomer.person.telephone ? this.getCustomer.person.telephone : ''
                        this.modelForm.gender = this.getCustomer.person.gender
                        this.modelForm.email = this.getCustomer.email
                        this.modelForm.factAddress = this.getCustomer.factAddress
                        this.modelForm.additionalInformation = this.getCustomer.person.additionalInformation
                    }

                    this.$root.showOverlay = false
                })
        }
    },
}
</script>

<style scoped>
.active {
    border: 3px solid #8300C5;
}

.button-stat {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background-color: #E5E5E5;
    color: #707070;
    font-size: 16px;
    height: 30px;
}

.button-stat:checked:active:focus {
    background-color: #6539B2 !important;
}

.button-stat:active {
    background-color: #6539B2 !important;
}
</style>
